import React from "react";
import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  ToastText,
} from "./ToastModalStyles";

const ToastModal = ({ message, onClose }) => {
  if (!message) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>×</CloseButton>
        <ToastText>{message}</ToastText>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ToastModal;
